import { apiInstance_ecom } from "@/app/api-config/axios-instance";
import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "modal",
  initialState: {
    isTermConditionModalOpen: false,
  },
  reducers: {
    showTermConditionModal: state => {
      state.isTermConditionModalOpen = true;
    },
    hideTermConditionModal: state => {
      state.isTermConditionModalOpen = false;
    },
  },
});

export const { showTermConditionModal, hideTermConditionModal } = modalSlice.actions;

export default modalSlice.reducer;

export const updateLatestVersion = async id => {
  try {
    const resposne = await apiInstance_ecom.post(
      `/terms/updateUserTermsVersion?userId=${id}`,
      {},
      {
        skipLoader: true,
      }
    );
    if (resposne.status == 200) {
      return { status: true };
    } else {
      return { status: false };
    }
  } catch (err) {
    return { status: false };
  }
};
